import Top from './Top.vue';

export default Top;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/components/top/index.ts